import { useMemo, useState } from "react";
import Header from "./components/header";
import DateInput from "@/components/custom/date-input";
import { Separator } from "@/components/ui/separator";
import ReportsTable from "./components/reports-table";
import { useTranslation } from "react-i18next";
import { Mixpanel } from "@/lib/mixpanel";
import { useGetTransactionsByDateRange } from "@/services/queries/transactions";
import { addDays, format } from "date-fns";
import Loading from "@/components/custom/loading";
import useVessel from "@/store/use-vessel";
const Reports = () => {
  const { t } = useTranslation();
  const { selectedVessel } = useVessel();
  const [startingDate, setStartingDate] = useState<Date>(
    addDays(new Date(), -10)
  );
  const [endingDate, setEndingDate] = useState<Date>(addDays(new Date(), 10));

  const { data, isPending } = useGetTransactionsByDateRange({
    fromDate: startingDate,
    toDate: endingDate,
    vesselId: selectedVessel?.id,
  });

  const transactions = useMemo(() => {
    return data?.value ?? [];
  }, [data]);

  return (
    <>
      <title>{t("title.reports")}</title>
      <div>
        <Header />
        <div className="mt-[21px] flex flex-row justify-center gap-2 px-5">
          <DateInput
            className="w-full max-w-[250px]"
            date={startingDate}
            setDate={(e) => {
              setStartingDate(e ?? new Date());
              Mixpanel.track("Select Starting Date of Reports");
            }}
            label={t("label.beginning")}
            max={format(endingDate, "yyyy-MM-dd")}
            data-testid="reports-starting-date-input"
          />

          <DateInput
            className="w-full max-w-[250px]"
            date={endingDate}
            setDate={(e) => {
              setEndingDate(e ?? new Date());
              Mixpanel.track("Select Ending Date of Reports");
            }}
            label={t("label.end")}
            min={format(startingDate, "yyyy-MM-dd")}
            data-testid="reports-ending-date-input"
          />
        </div>
        <Separator className="my-[21px]" />
        {isPending ? <Loading /> : <ReportsTable transactions={transactions} />}
      </div>
    </>
  );
};

export default Reports;
